var Projects = require('./gen/projects');

module.exports = Projects;


//////////////////
// WEBPACK FOOTER
// ./node_modules/asana/lib/resources/projects.js
// module id = 1450
// module chunks = 0